if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');

        this.prevButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.navigate(-1);
        });

        this.nextButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.navigate(1);
        });

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.navigate(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.navigate(1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.updateNavigationState();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content [data-media-id]'));
      }

      getActiveMediaId() {
        const activeMedia = this.querySelector('.product-media-modal__content [data-media-id].active');
        if (activeMedia) return activeMedia.getAttribute('data-media-id');

        if (this.openedBy) {
          return this.openedBy.getAttribute('data-media-id');
        }

        return null;
      }

      navigate(direction) {
        const mediaItems = this.getMediaItems();
        if (mediaItems.length <= 1) return;

        const activeMediaId = this.getActiveMediaId();
        let activeIndex = mediaItems.findIndex(
          (element) => element.getAttribute('data-media-id') === activeMediaId
        );

        if (activeIndex < 0) activeIndex = 0;
        const nextIndex = (activeIndex + direction + mediaItems.length) % mediaItems.length;
        this.activateMedia(mediaItems[nextIndex]);
      }

      activateMedia(activeMedia) {
        if (!activeMedia) return;

        this.getMediaItems().forEach((element) => {
          element.classList.remove('active');
          element.style.display = 'none';
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.classList.add('active');
        activeMedia.style.display = 'block';
        activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.updateNavigationState();
      }

      updateNavigationState() {
        const hasMultipleItems = this.getMediaItems().length > 1;
        this.classList.toggle('product-media-modal--has-nav', hasMultipleItems);
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        const activeMediaId = this.openedBy.getAttribute('data-media-id');
        const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
        this.activateMedia(activeMedia);
      }
    }
  );
}
